import InfluencerDetails from '@src/quince-site-common/src/domains/InfluencerDetails'
import PubSub from '../PubSub'
import Product from '../../domains/Product'

export interface SocialSectionState {
  showPopUp: boolean
  influencerDetails: InfluencerDetails[]
  influencerIndex: number
  isLoadingProducts: boolean
  products?: Product[]
}

interface SetInfluencerPayload {
  influencerDetails: InfluencerDetails[]
  influencerIndex: number
  isLoadingProducts: boolean
  products?: Product[]
}

class SocialSectionStateManager extends PubSub {
  private socialSectionState: SocialSectionState

  constructor() {
    super()
    this.socialSectionState = {
      showPopUp: false,
      influencerDetails: [],
      influencerIndex: 0,
      products: [],
      isLoadingProducts: true,
    }
  }

  updateProductsAndLoadingState = (loadingState: boolean, products?: Product[]) => {
    if (this.socialSectionState.isLoadingProducts === loadingState && this.socialSectionState.products === products) {
      return
    }
    this.socialSectionState.isLoadingProducts = loadingState
    this.socialSectionState.products = products
    this.publish()
  }

  showSocialSectionPopUp = (payload: SetInfluencerPayload) => {
    this.socialSectionState.showPopUp = true
    this.socialSectionState.influencerDetails = payload.influencerDetails
    this.socialSectionState.influencerIndex = payload.influencerIndex
    this.socialSectionState.isLoadingProducts = payload.isLoadingProducts
    this.socialSectionState.products = payload.products
    this.publish()
  }

  hideSocialSectionPopUp = () => {
    this.socialSectionState.showPopUp = false
    this.publish()
  }

  getSocialSectionState = () => this.socialSectionState
}

const socialSectionStateManager: SocialSectionStateManager =
  SocialSectionStateManager.getInstance('socialSectionStateManager')

export default socialSectionStateManager
